export const SET_SUBSCRIPTION_SYSTEM = 'subscriptionSearch/SET_SUBSCRIPTION_SYSTEM';
export const SET_SUBSCRIPTIONS = 'subscriptionSearch/SET_SUBSCRIPTIONS';
export const SELECT_SUBSCRIPTION = 'subscriptionSearch/SELECT_SUBSCRIPTION';
export const SELECT_SUBSCRIPTION_TASK = 'subscriptionSearch/SELECT_SUBSCRIPTION_TASK';
export const SET_SHOP_CONTEXT = 'subscriptionSearch/SET_SHOP_CONTEXT';

// macro wizard search order actions
export const SET_SEARCH_TYPE = 'subscriptionsSearch/SET_SEARCH_TYPE';
export const SET_SEARCH_VALUE = 'subscriptionsSearch/SET_SEARCH_VALUE';
export const REMOVE_QUEUED_CHARGE = 'subscriptionsSearch/REMOVE_QUEUED_CHARGE';
export const SET_SUBSCRIPTION_ORDERS = 'subscriptionsSearch/SET_SUBSCRIPTION_ORDERS';
export const SELECT_SUBSCRIPTION_IN_DECISION_TREE = 'subscriptionSearch/SELECT_SUBSCRIPTION_IN_DECISION_TREE';
export const UNSELECT_SUBSCRIPTION_IN_DECISION_TREE = 'subscriptionSearch/UNSELECT_SUBSCRIPTION_IN_DECISION_TREE';
export const UNSELECT_ALL_SUBSCRIPTIONS_IN_DECISION_TREE =
  'subscriptionSearch/UNSELECT_ALL_SUBSCRIPTIONS_IN_DECISION_TREE';
export const UPDATE_SUBSCRIPTION = 'subscriptionSearch/UPDATE_SUBSCRIPTION';
export const SET_SELECTED_SUBSCRIPTION_FOR_CONFIRMATION_PAGE =
  'subscriptionSearch/SET_SELECTED_SUBSCRIPTION_FOR_CONFIRMATION_PAGE';
export const SET_SUBSCRIPTION_SEARCH = 'SET_SUBSCRIPTION_SEARCH';
export const SET_PAUSE_SUBSCRIPTION = 'SET_PAUSE_SUBSCRIPTION';
